import { createContext, type ReactNode, useContext, useMemo } from 'react';
import { type WrapFn } from './types';

export interface ShadowGlobalProps {
  mode?: ShadowRootMode;
  wrap?: WrapFn;
}

const ShadowGlobalPropsContext = createContext<ShadowGlobalProps | undefined>(
  undefined
);

export interface ShadowGlobalPropsProviderProps {
  mode?: ShadowRootMode;
  wrap?: WrapFn;
  children?: ReactNode;
}

export function ShadowGlobalPropsProvider({
  mode,
  wrap,
  children
}: ShadowGlobalPropsProviderProps) {
  const globalProps: ShadowGlobalProps = useMemo(
    () => ({ mode, wrap }),
    [mode, wrap]
  );

  return (
    <ShadowGlobalPropsContext.Provider value={globalProps}>
      {children}
    </ShadowGlobalPropsContext.Provider>
  );
}

export function useShadowGlobalProps() {
  return useContext(ShadowGlobalPropsContext);
}
